<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          small
          text
          outlined
          rounded
          class="ma-2"
          >EDIT MATTER</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                "
      >
        <v-card-title>
          EDIT
          <span class="red--text">MATTER</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onSaveChanges" ref="form">
          <div>
            <!-- <v-card
              style="background-color: black; border-radius: 26px; max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            > -->
            <v-text-field
              label="CASE NAME"
              name="caseName"
              validate-on-blur
              required
              id="caseName"
              class="ma-2"
              v-model="caseName"
              autofocus
              clearable
              dense
              filled
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>
            <v-text-field
              label="CASE NUMBER"
              name="caseNumber"
              validate-on-blur
              required
              id="caseNumber"
              class="ma-2"
              filled
              v-model="caseNumber"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>

            <v-text-field
              v-model="dateOfLoss"
              label="DATE OF LOSS"
              name="dateOfLoss"
              validate-on-blur
              required
              id="dateOfLoss"
              class="ma-2"
              filled
              clearable
              color="#2E5473"
              outlined
              dense
              v-mask="dateMask"
              hint="MM/DD/YYYY"
              persistent-hint
              @change="logChange"
            ></v-text-field>

            <!-- causes of actions -->

            <form @submit.prevent="addCauseOfAction">
              <v-layout row wrap class="ma-2">
                <v-text-field
                  class="ma-auto"
                  label="ADD CAUSES OF ACTION"
                  v-model="causeOfAction"
                  clearable
                  name="causeOfAction"
                  validate-on-blur
                  required
                  id="causeOfAction"
                  filled
                  dense
                  style="max-width: 400px"
                  color="#2E5473"
                  outlined
                  @change="logChange"
                ></v-text-field>
                <v-btn fab small color="green" filled @click="addCauseOfAction">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-layout>
              <v-list
                two-line
                class="ma-auto"
                style="background-color: black; border: 1px dashed red; max-width: 400px; max-height: 40px; border-radius: 10px"
                v-for="(cause, index) in causesOfAction"
                :key="index"
              >
                <v-layout row wrap>
                  <div class="subheading body-1 font-weight-bold ml-4">
                    #{{ index + 1 }}: {{ cause }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-icon color="red darken-2" @click="removeCause(index)"
                    >mdi-minus-circle</v-icon
                  >
                </v-layout>
              </v-list>
            </form>
            <v-checkbox
              label="MARK IF THIS IS THIS A COORDINATION PROCEEDING"
              v-model="coordinationProceeding"
              color="#2E5473"
            ></v-checkbox>
            <v-expand-transition>
              <v-text-field
                label="SPECIAL TITLE OF COORDINATION PROCEEDING"
                name="specialTitle"
                validate-on-blur
                id="specialTitle"
                class="ma-2"
                filled
                v-model="specialTitle"
                clearable
                dense
                v-if="coordinationProceeding"
                color="#2E5473"
                outlined
              ></v-text-field>
            </v-expand-transition>
            <v-text-field
              label="JURISDICTION STATE"
              name="jdxState"
              validate-on-blur
              required
              id="jdxState"
              class="ma-2"
              filled
              v-model="jdxState"
              clearable
              dense
              outlined
              color="#2E5473"
              @change="logChange"
            ></v-text-field>
            <v-text-field
              label="JURISDICTION COUNTY and DISTRICT"
              name="jdxCounty"
              validate-on-blur
              required
              id="jdxCounty"
              class="ma-2"
              filled
              v-model="jdxCounty"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>

            <v-text-field
              label="COURTHOUSE NAME (OPTIONAL)"
              name="jdxCourtHouseName"
              validate-on-blur
              required
              id="jdxCourtHouseName"
              class="ma-2"
              filled
              v-model="jdxCourtHouseName"
              clearable
              dense
              color="#2E5473"
              @change="logChange"
            ></v-text-field>

            <v-text-field
              label="COURTHOUSE STREET ADDRESS (OPTIONAL)"
              name="jdxCourtHouseStreetAddressLine1"
              validate-on-blur
              required
              id="jdxCourtHouseStreetAddressLine1"
              class="ma-2"
              filled
              v-model="jdxCourtHouseStreetAddressLine1"
              clearable
              dense
              color="#2E5473"
              outlined
            ></v-text-field>

            <v-text-field
              label="COURTHOUSE CITY (OPTIONAL)"
              name="jdxCourtHouseCity"
              validate-on-blur
              required
              id="jdxCourtHouseCity"
              class="ma-2"
              filled
              v-model="jdxCourtHouseCity"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>

            <v-text-field
              label="COURTHOUSE STATE (OPTIONAL)"
              name="jdxCourtHouseState"
              validate-on-blur
              required
              id="jdxCourtHouseState"
              class="ma-2"
              filled
              v-model="jdxCourtHouseState"
              clearable
              dense
              color="#2E5473"
              @change="logChange"
            ></v-text-field>
            <v-text-field
              label="COURTHOUSE ZIP (OPTIONAL)"
              name="jdxCourtHouseZip"
              validate-on-blur
              required
              id="jdxCourtHouseZip"
              class="ma-2"
              filled
              v-model="jdxCourtHouseZip"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>
            <v-text-field
              label="DEPARTMENT (OPTIONAL)"
              name="jdxDepartment"
              validate-on-blur
              required
              id="jdxDepartment"
              class="ma-2"
              filled
              v-model="jdxDepartment"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>
            <v-text-field
              label="JUDGE (OPTIONAL)"
              name="jdxJudge"
              validate-on-blur
              required
              id="jdxJudge"
              class="ma-2"
              filled
              v-model="jdxJudge"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>

            <v-select
              label="STATUS"
              name="status"
              validate-on-blur
              required
              id="status"
              class="ma-2"
              filled
              v-model="status"
              clearable
              chips
              deletable-chips
              :items="statuses"
              height="50px"
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-select>

            <v-text-field
              label="INTERNAL ID"
              name="id"
              validate-on-blur
              required
              id="id"
              class="ma-2"
              filled
              v-model="internalID"
              clearable
              dense
              color="#2E5473"
              outlined
              @change="logChange"
            ></v-text-field>

            <!-- <div class="ma-2">
                <v-file-input
                  outlined
                  chips
                  multiple
                  label="Upload Initial Documents"
                  ref="fileInput"
                  @change="logChange"
                  dense
                ></v-file-input>
              </div>
              <v-card>
                <ol class="ma-auto">
                  <li v-for="(file, index) in initialDocs" :key="index">
                    <v-layout>
                      <div class="ma-auto">{{file.name}}</div>
                      <v-btn small text rounded @click="removeFile(index)">
                        <v-icon color="red">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-layout>
                  </li>
                </ol>
              </v-card>-->
            <!-- </v-card> -->
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >SUBMIT</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
        <!-- <v-card-actions>
					<v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						color="black"
						:disabled="!formIsValid"
						dark
						type="submit"
						@click="onSaveChanges"
					>SUBMIT</v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </v-row>
  <!-- </div> -->
</template>

<script>
/**
 *
 * this component is not complete
 * this component must be changed to mach the newest version of CreateMatter component
 *
 *
 *
 */

import * as moment from "moment";
import { mask } from "vue-the-mask";

// import slugify from "slugify";
export default {
  directives: {
    mask
  },
  props: ["matter"],
  data() {
    return {
      dialog: false,
      menu: false,
      allowSave: false,
      allowSaveCauses: true,
      statuses: ["steady", "complete", "urgent", "steady"],
      caseName: this.matter.caseName,
      caseNumber: this.matter.caseNumber,
      dateOfLoss: this.matter.dateOfLoss,
      dateMask: "##/##/####",
      internalID: this.matter.internalID,
      causeOfAction: null,
      causesOfAction: this.matter.causesOfAction,
      coordinationProceeding: this.matter.coordinationProceeding,
      specialTitle: this.matter.specialTitle,
      // causesOfAction: this.causes,
      status: this.matter.status,
      // menu: false,

      // initialDocs: [],
      // initialDocs: this.matter.initialDocs,
      matterSlug: this.matter.matterSlug,
      jdxState: this.matter.jdxState,
      jdxCounty: this.matter.jdxCounty,
      jdxCourtHouseName: this.matter.jdxCourtHouseName,
      jdxCourtHouseStreetAddressLine1: this.matter
        .jdxCourtHouseStreetAddressLine1,

      jdxCourtHouseCity: this.matter.jdxCourtHouseCity,
      jdxCourtHouseState: this.matter.jdxCourtHouseState,
      jdxCourtHouseZip: this.matter.jdxCourtHouseZip,
      jdxDepartment: this.matter.jdxDepartment,
      jdxJudge: this.matter.jdxJudge
    };
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  computed: {
    formattedDateOfLoss() {
      if (this.dateOfLoss !== null && this.dateOfLoss !== undefined) {
        let date = moment(this.dateOfLoss).format("YYYY-MM-DD");
        console.log("formattedDateOfLoss", date);
        return date;
      } else {
        return null;
      }
    },
    formIsValid() {
      return (
        this.caseName !== null &&
        this.dateOfLoss !== null &&
        this.status !== null &&
        this.allowSave == true &&
        this.allowSaveCauses == true
      );
    },
    user() {
      return this.$store.getters.user;
    }
    // matter() {
    //   return this.$store.getters.getMatter(this.id);
    // }
    // causes() {
    //   let causelist = [];
    //   this.matter.causesOfAction.forEach(cause => {
    //     causelist.push(cause);
    //   });
    //   return causelist;
    // }
    // }
    // title() {
    //   return this.matter.title;
    // },
  },
  methods: {
    addCauseOfAction() {
      if (confirm("are you sure you want to change the causes of action?")) {
        this.causesOfAction.push(this.causeOfAction.toUpperCase());
        this.allowSaveCauses = true;
        this.causeOfAction = null;
      } else {
        this.allowSaveCauses = false;
      }
      // this.causesOfAction.push(this.causeOfAction.toUpperCase());

      // this.causeOfAction = null;
    },
    removeCause(index) {
      this.causesOfAction.splice(index, 1);
    },
    // onFilePicked() {
    //   if (event.target.files) {
    //     const fileList = Array.from(event.target.files);
    //     fileList.forEach(file => {
    //       this.initialDocs.push(file);
    //     });
    //   }
    // },

    // removeFile(index) {
    //   this.initialDocs.splice(index, 1);
    // },
    cancelDialog() {
      this.menu = false;

      this.caseName = this.matter.caseName;
      this.caseNumber = this.matter.caseNumber;
      this.dateOfLoss = this.matter.dateOfLoss;
      this.internalID = this.matter.internalID;
      this.causeOfAction = null;
      // this.causesOfAction = [];
      // this.causesOfAction = this.matter.causesOfAction;
      this.causesOfAction = this.matter.causesOfAction;
      this.coordinationProceeding = this.matter.coordinationProceeding;
      this.specialTitle = this.matter.specialTitle;
      this.status = this.matter.status;

      // this.initialDocs = this.matter.initialDocs;
      // this.initialDocs = [];
      this.matterSlug = this.matter.matterSlug;
      this.jdxState = this.matter.jdxState;
      this.jdxCounty = this.matter.jdxCounty;
      this.jdxCourtHouseName = this.matter.jdxCourtHouseName;
      this.jdxCourtHouseStreetAddressLine1 = this.matter.jdxCourtHouseStreetAddressLine1;

      this.jdxCourtHouseCity = this.matter.jdxCourtHouseCity;
      this.jdxCourtHouseState = this.matter.jdxCourtHouseState;
      this.jdxCourtHouseZip = this.matter.jdxCourtHouseZip;
      this.jdxDepartment = this.matter.jdxDepartment;
      this.jdxJudge = this.matter.jdxJudge;

      this.allowSave = false;
      this.allowSaveCauses = true;
      this.dialog = false;
    },
    onSaveChanges() {
      if (this.caseName.trim() === "" || this.status.trim() === "") {
        return;
      }

      if (!this.formIsValid) {
        return;
      }
      // this.matterSlug = slugify(this.caseName, {
      //   replacement: "-",
      //   remove: /[$*_+~.()'"!\-:@,]/g,
      //   lower: true
      // });

      // create an object with the edited data

      const changes = {
        caseName: this.caseName.trim(),
        dateOfLoss: this.formattedDateOfLoss,

        caseNumber: this.caseNumber,

        internalID: this.internalID,

        causesOfAction: this.causesOfAction,
        status: this.status,
        // menu: false,
        coordinationProceeding: this.coordinationProceeding,
        specialTitle: this.specialTitle,
        matterSlug: this.matter.matterSlug,
        jdxState: this.jdxState,
        jdxCounty: this.jdxCounty,
        jdxCourtHouseName: this.jdxCourtHouseName,
        jdxCourtHouseStreetAddressLine1: this.jdxCourtHouseStreetAddressLine1,

        jdxCourtHouseCity: this.jdxCourtHouseCity,
        jdxCourtHouseState: this.jdxCourtHouseState,
        jdxCourtHouseZip: this.jdxCourtHouseZip,
        jdxDepartment: this.jdxDepartment,
        jdxJudge: this.jdxJudge
      };
      //this doesn't work when you are from a diffrent firm
      // const firmSlug = this.user.firmSlug;
      const firmSlug = this.matter.firms[0].firmSlug;

      // const originalMatterSlug = this.matter.matterSlug;
      // const initialDocs = this.initialDocs;

      // const originalInitialDocs = [];
      // if (this.matter.initialDocUrls.length > 0) {
      //   this.matter.initialDocUrls.forEach(doc => {
      //     originalInitialDocs.push({ name: doc.name });
      //   });
      // }

      // log new data with changes
      // console.log(changes);
      const payload = {
        changes,
        firmSlug
        // initialDocs,
        // originalInitialDocs
      };
      console.log(payload);
      console.log("causes", this.causes);

      // send data to store action

      this.$store.dispatch("editMatter", payload);

      this.dialog = false;
    },

    logChange(event) {
      console.log("something changed");
      console.log(event);
      this.allowSave = true;
    }
    // logChangeCauses() {
    //   if (!confirm("are you sure you want to change causes of action?")) {
    //     this.allowSaveCauses = false;
    //   }
    // }
  },
  created() {
    console.log(this.matter);
  }
};
</script>

<style scoped></style>
